import { Script } from "gatsby";

function CookieScript() {
    return <Script src="//cdn.cookie-script.com/s/52029b9efafa38bbb51d3e4b72c20716.js" async />
}

export default CookieScript